import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Rsvp.css';
import Counter from './Counter';
import BackButton from './Backbutton';

// Google Apps Script Web app URL. Deploy apps-script/Code.gs as a web app
// ("Execute as: Me", "Who has access: Anyone") and paste the /exec URL here.
// See apps-script/README.md.
const SCRIPT_URL = "https://script.google.com/macros/s/AKfycby59DoMtpEjsdYCgK3xRwY_CrHJCqgr_FgBuwAl8vVlwN2gfb8gp6mRj28DOVNHU0sc/exec";

// Must match FORM_TOKEN in apps-script/Code.gs. Not a secret (it ships in this
// bundle); it just filters out bots hitting the bare endpoint.
const FORM_TOKEN = "3K43ad4d-Hjy5QP8yOFwXpuW";

const Rsvp = ({ partyDetails }) => {
  const [attendance, setAttendance] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    adults: 1,
    kids: 0,
    comments: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const honeypotRef = useRef(null);
  const navigate = useNavigate();

  const rsvpContact = partyDetails && partyDetails.rsvpContact;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleCounterChange = (name, value) => {
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    const submissionData = new FormData();
    submissionData.append('token', FORM_TOKEN);
    submissionData.append('company', honeypotRef.current ? honeypotRef.current.value : '');
    submissionData.append('attendance', attendance);
    submissionData.append('name', formData.name.trim());
    submissionData.append('phone', formData.phone.trim());
    submissionData.append('comments', formData.comments.trim());
    if (attendance === 'yes' || attendance === 'maybe') {
      submissionData.append('email', formData.email.trim());
      submissionData.append('adults', formData.adults);
      submissionData.append('kids', formData.kids);
    }

    try {
      const response = await fetch(SCRIPT_URL, { method: 'POST', body: submissionData });
      const text = await response.text();

      let ok = response.ok;
      try { ok = JSON.parse(text).result === 'success'; } catch (_) { /* non-JSON response */ }
      if (!ok) throw new Error(text.slice(0, 140) || `HTTP ${response.status}`);

      const going = attendance === 'yes' || attendance === 'maybe';
      navigate('/rsvp/confirmed', {
        replace: true,
        state: {
          rsvp: {
            attendance,
            name: formData.name.trim(),
            email: going ? formData.email.trim() : '',
            adults: going ? formData.adults : null,
            kids: going ? formData.kids : null
          }
        }
      });
    } catch (err) {
      console.error('RSVP submit failed:', err);
      setError(
        'Sorry — we could not save your RSVP just now. Please try again in a minute' +
        (rsvpContact ? `, or contact ${rsvpContact}.` : '.')
      );
      setIsSubmitting(false);
    }
  };
  return (
    <main className="rsvp-main">
      {/* --- ADD THE BACK BUTTON HERE --- */}
      <BackButton />

      <form className="card rsvp-form" onSubmit={handleSubmit}>
        <h2>RSVP</h2>

        {/* Honeypot: hidden from people, catches bots that fill every field. */}
        <div className="hp-field" aria-hidden="true">
          <label>
            Company
            <input ref={honeypotRef} type="text" name="company" tabIndex={-1} autoComplete="off" />
          </label>
        </div>

        <fieldset className="attendance-group">
          {/* ... rest of the form is unchanged ... */}
          <legend>Will you be able to join the fun?</legend>
          <label>
            <input type="radio" value="yes" checked={attendance === 'yes'} onChange={(e) => setAttendance(e.target.value)} />
            Yes, we'll be there!
          </label>
          <label>
            <input type="radio" value="maybe" checked={attendance === 'maybe'} onChange={(e) => setAttendance(e.target.value)} />
            Maybe, we'll try our best!
          </label>
          <label>
            <input type="radio" value="no" checked={attendance === 'no'} onChange={(e) => setAttendance(e.target.value)} />
            Sorry, we can't make it.
          </label>
        </fieldset>
        
        {(attendance === 'yes' || attendance === 'maybe') && (
          <div className="form-fields">
            <label>Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleInputChange} required />
            
            <label>Phone Number</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} required />

            <label>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleInputChange} required />
            <p className="field-hint">We'll email you the Pump It Up waiver to complete before the party.</p>

            <div className="guest-count">
              <Counter 
                label="Number of Adults"
                value={formData.adults}
                onIncrement={() => handleCounterChange('adults', formData.adults + 1)}
                onDecrement={() => handleCounterChange('adults', Math.max(1, formData.adults - 1))}
              />
              <Counter 
                label="Number of Kids"
                value={formData.kids}
                onIncrement={() => handleCounterChange('kids', formData.kids + 1)}
                onDecrement={() => handleCounterChange('kids', Math.max(0, formData.kids - 1))}
              />
            </div>

            <label>Any other comments? (optional)</label>
            <textarea name="comments" value={formData.comments} onChange={handleInputChange}></textarea>
          </div>
        )}

        {attendance === 'no' && (
          <div className="form-fields">
            <label>Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleInputChange} required />
            
            <label>Phone Number</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} required />

            <label>Leave a message? (optional)</label>
            <textarea name="comments" value={formData.comments} onChange={handleInputChange}></textarea>
          </div>
        )}

        {error && <p className="form-error" role="alert">{error}</p>}

        {attendance && (
          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? 'Sending…' : 'Send RSVP'}
          </button>
        )}
      </form>
    </main>
  );
};

export default Rsvp;
